'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var rotateOutUpRight = {
  from: {
    transformOrigin: 'right bottom',
    opacity: 1
  },
  to: {
    transformOrigin: 'right bottom',
    transform: (0, _utils.rotate3d)(0, 0, 1, 90),
    opacity: 0
  }
};
exports.default = rotateOutUpRight;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/rotate-out-up-right.js
// module id = 2157
// module chunks = 0